"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IconButton;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../svg/Icon");
var _IconAble = require("../svg/IconAble");
var _utility = require("../utility");
var _excluded = ["icon", "able", "onClick", "events", "number", "size", "className", "active", "outline"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function IconButton(_ref) {
  var icon = _ref.icon,
    able = _ref.able,
    onClick = _ref.onClick,
    events = _ref.events,
    number = _ref.number,
    size = _ref.size,
    className = _ref.className,
    active = _ref.active,
    outline = _ref.outline,
    props = _objectWithoutProperties(_ref, _excluded);
  var buttonClass = (0, _utility.classNames)('tl-icon-button', "tl-icon-button-".concat(size), className, active ? "tl-active" : '', outline ? '' : 'tl-no-outline');
  var isAbleButton = number === undefined && able === true && icon !== undefined;
  var buttonContent = null;
  if (number !== undefined) {
    buttonContent = /*#__PURE__*/_react.default.createElement("div", {
      className: "tl-icon-number"
    }, number);
  } else if (isAbleButton) {
    buttonContent = /*#__PURE__*/_react.default.createElement(_IconAble.IconAble, {
      icon: icon
    });
  } else if (icon) {
    buttonContent = /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
      name: icon,
      className: "able-icon tl-default-svg-class"
    });
  }
  var button = /*#__PURE__*/_react.default.createElement("button", _extends({
    className: buttonClass,
    type: "button"
  }, events, props, {
    onClick: onClick
  }), buttonContent);
  return button;
}
var defaultProps = {
  able: false,
  size: 'Default',
  icon: 'Chat',
  outline: true
};
IconButton.defaultProps = defaultProps;